// AUTO-GENERATED - DO NOT EDIT!
import gql from "graphql-tag";
import { useMutation, MutationHookOptions } from "@apollo/client";
import { nhsLoginAuth, nhsLoginAuthVariables } from "../types/nhsLoginAuth";

export const useNhsLoginAuthMutation = (
  opts: MutationHookOptions<nhsLoginAuth, nhsLoginAuthVariables>
) => {
  return useMutation<nhsLoginAuth, nhsLoginAuthVariables>(
    nhsLoginAuthMutation,
    opts
  );
};

export const nhsLoginAuthMutation = gql`
  mutation nhsLoginAuth(
    $authCode: String!
    $redirectUri: String!
    $nonce: String!
  ) {
    nhsLoginAuth(
      authorizationCode: $authCode
      redirectUri: $redirectUri
      nonce: $nonce
    ) {
      setupToken
      setupStatus
      tokens {
        accessToken
        refreshToken
      }
      account {
        id
        intercomId
        email
        firstName
        lastName
        emailMarketingConsent {
          given
        }
        intercomUserHash
        patients {
          totalCount
          edges {
            node {
              id
              isAccountHolder
            }
          }
        }
      }
      error
      errorDescription
      validationErrors {
        field
        message
      }
    }
  }
`;
